export class PaginationHandler<T> {
    private _currentPage: number;
    private _totalPages: number;
    private _pageSize: number;
    private _totalItems: number;
    private _items: T[];
    private _paginatedItems: T[][];

    constructor(items: T[], pageSize: number) {
        this._currentPage = 1;
        this._pageSize = pageSize;
        this._totalItems = items.length;
        this._totalPages = 0;
        this._items = items;
        this._paginatedItems = this.chunkArray(pageSize);
    }

    private chunkArray(size: number): T[][] {
        const chunked: T[][] = [];
        for (let i = 0; i < this._items.length; i += size) {
            chunked.push(this._items.slice(i, i + size));
        }

        this._totalPages = chunked.length;

        return chunked;
    }

    get currentPage(): number {
        return this._currentPage;
    }

    get totalPages(): number {
        return this._totalPages;
    }

    get pageSize(): number {
        return this._pageSize;
    }

    get totalItems(): number {
        return this._totalItems;
    }

    get items(): T[] {
        return this._items;
    }

    get paginatedItems(): T[][] {
        return this._paginatedItems;
    }

    getCurrentPageItems(): T[] {
        return this._paginatedItems[this._currentPage - 1] || [];
    }

    hasNextPage(): boolean {
        return this._currentPage < this._totalPages;
    }

    hasPrevPage(): boolean {
        return this._currentPage > 1;
    }

    nextPage(): void {
        if (this.hasNextPage()) {
            this._currentPage++;
            console.log(this._currentPage);
        }
    }

    prevPage(): void {
        if (this.hasPrevPage()) {
            this._currentPage--;
        }
    }

    goToPage(page: number): void {
        if (page >= 1 && page <= this._totalPages) {
            this._currentPage = page;
        }
    }

    getPaginationInfo(): { start: number; end: number } {
        const start = (this._currentPage - 1) * this._pageSize + 1;
        const end = Math.min(
            start +
                this.getCurrentPageItems().length -
                (this._currentPage < this._paginatedItems.length ? 1 : 0),
            this._totalItems
        );
        return { start, end };
    }
}
